export default "__VITE_PUBLIC_ASSET__6b882897__"